function urlB64ToUint8Array(base64String) {
    const padding = '='.repeat((4 - base64String.length % 4) % 4);
    const base64 = (base64String + padding)
        .replace(/\-/g, '+')
        .replace(/_/g, '/');

    const rawData = window.atob(base64);
    const outputArray = new Uint8Array(rawData.length);

    for (var i = 0; i < rawData.length; ++i) {
        outputArray[i] = rawData.charCodeAt(i);
    }
    return outputArray;
}

function swHelper_subscribeFunction() {
    if (swHelper.swRegistration == undefined)
        throw "Error: swHelper.subscribe: You Should register sw first";
    if (swHelper.applicationServerPublicKey == undefined)
        throw "Error: swHelper.subscribe: You Should set applicationServerPublicKey first";
    const applicationServerKey = urlB64ToUint8Array(swHelper.applicationServerPublicKey);
    swHelper.swRegistration.pushManager
        .subscribe({
            userVisibleOnly: true,
            applicationServerKey: applicationServerKey
        })
        .then(function (subscription) {
            swHelper.isSubscribed = true;
            if (swHelper.onSubscribed != undefined)
                swHelper.onSubscribed(subscription);
        })
        .catch(function (err) {
            window.console.log('Failed to subscribe the user: ', err);
        });
}

function swHelper_unsubscribeFunction() {
    if (swHelper.isSubscribed == false)
        throw "Error: swHelper.unsubscribe: not subscribed";

    swHelper.swRegistration.pushManager.getSubscription()
        .then(function (subscription) {
            if (subscription) {
                return subscription.unsubscribe();
            }
        })
        .catch(function (error) {
            window.console.log('Error unsubscribing', error);
        })
        .then(function () {
            swHelper.isSubscribed = false;
            if (swHelper.onUnsubscribed != undefined)
                swHelper.onUnsubscribed();
        });
}

var swHelper_initializeFunction = function (key) {
    swHelper.applicationServerPublicKey = key
    navigator.serviceWorker.register('/sw.js')
        .then(function (swReg) {
            swHelper.swRegistration = swReg;
            if(!swReg.pushManager) {
                if(swHelper.onPushManagerNotSupported) swHelper.onPushManagerNotSupported()
                return
            }
            swReg.pushManager.getSubscription()
                .then(function (subscription) {
                    if (subscription != null) {
                        swHelper.isSubscribed = true;
                        if (swHelper.onSubscribed != undefined)
                            swHelper.onSubscribed(subscription);
                    }
                }).finally(() => {
                    if (swHelper.onRegistered != undefined) swHelper.onRegistered();
                })
        })
        .catch(function (error) {
            window.console.error('Service Worker Error', error);
        });
}

var swHelper = {
    "isBrowserSupportServiceWorker": ('serviceWorker' in navigator),
    "initialize": swHelper_initializeFunction,
    // members
    "applicationServerPublicKey": undefined,
    "isSubscribed": false,
    "swRegistration": undefined,
    // methods
    "subscribe": swHelper_subscribeFunction,
    "unsubscribe": swHelper_unsubscribeFunction,
    // listener
    "onRegistered": undefined,
    "onSubscribed": undefined,
    "onUnsubscribed": undefined,
    "onPushManagerNotSupported": undefined
}
export default swHelper;